'use client';

import { useState } from 'react';
import { Linkedin, Twitter, Link as LinkIcon, Check } from 'lucide-react';

interface ShareButtonsProps {
  url: string;
  title: string;
}

export default function ShareButtons({ url, title }: ShareButtonsProps) {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      console.error('Failed to copy link');
    }
  };

  const linkedinShareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
  const twitterShareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`;

  return (
    <div className="flex items-center gap-3 py-6 border-t border-slate-200">
      <span className="text-sm font-medium text-slate-600">Поделиться:</span>

      {/* LinkedIn Share */}
      <a
        href={linkedinShareUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center p-2 rounded-lg border border-slate-200 hover:border-blue-500 hover:bg-blue-50 transition-colors"
        aria-label="Share on LinkedIn"
      >
        <Linkedin size={20} className="text-blue-600" />
      </a>

      {/* Twitter Share */}
      <a
        href={twitterShareUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center p-2 rounded-lg border border-slate-200 hover:border-black hover:bg-slate-100 transition-colors"
        aria-label="Share on X (Twitter)"
      >
        <Twitter size={20} className="text-black" />
      </a>

      {/* Copy Link */}
      <button
        onClick={handleCopyLink}
        className="inline-flex items-center justify-center p-2 rounded-lg border border-slate-200 hover:border-keiro-green hover:bg-keiro-mist transition-colors"
        aria-label="Copy link"
      >
        {copied ? (
          <Check size={20} className="text-keiro-green" />
        ) : (
          <LinkIcon size={20} className="text-slate-600" />
        )}
      </button>
    </div>
  );
}
